import { render, staticRenderFns } from "./laudo.vue?vue&type=template&id=01fa67f5"
import script from "./laudo.vue?vue&type=script&lang=js"
export * from "./laudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports